import { USER_PROFILE_POSTS_ENTITY } from '../../../constants/entity'
import { EntityTabPosts } from '../../EntityTab'

import {
  USER_PROFILE_TAB_POSTS_CREATED_BY_FILTER_KEY,
  USER_PROFILE_TAB_POSTS_QA_NAME,
} from './UserProfileTabPosts.constants'

function UserProfileTabPosts({ userData }) {
  return (
    <EntityTabPosts
      canSearch
      filterEntity={USER_PROFILE_POSTS_ENTITY}
      key={userData?.id}
      qaName={USER_PROFILE_TAB_POSTS_QA_NAME}
      scopeFilterKey={USER_PROFILE_TAB_POSTS_CREATED_BY_FILTER_KEY}
      scopeId={userData?.id}
    />
  )
}

export default UserProfileTabPosts
